import { useState, useEffect } from 'react'
import { synapseAPI } from '../lib/synapse-api'

interface Feedback {
  id: string
  project: string
  message: string
  status: string
  timestamp: string
  email?: string
}

export function FeedbackPage() {
  const [feedbacks, setFeedbacks] = useState<Feedback[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadFeedback()
  }, [])

  const loadFeedback = async () => {
    try {
      const data = await synapseAPI.getFeedback()
      setFeedbacks(data.feedbacks || [])
    } catch (err) {
      console.error('Failed to load feedback:', err)
    } finally {
      setLoading(false)
    }
  }

  const formatDate = (ts: string) => {
    try {
      return new Date(ts).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    } catch {
      return ts
    }
  }

  if (loading) {
    return (
      <main className="flex-1 p-6 overflow-y-auto">
        <div className="text-gray-400">Loading feedback...</div>
      </main>
    )
  }

  return (
    <main className="flex-1 p-6 overflow-y-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white mb-2">Edit Requests</h1>
        <p className="text-gray-400">Client feedback and change requests</p>
      </div>

      <div className="space-y-4">
        {feedbacks.map((fb) => (
          <div
            key={fb.id}
            className="bg-[#161b22] border border-[#30363d] rounded-lg p-4"
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-3">
                <span className="px-2 py-0.5 bg-cyan-500/20 text-cyan-400 rounded text-xs">
                  {fb.project}
                </span>
                <span className={`px-2 py-0.5 rounded text-xs ${
                  fb.status === 'completed'
                    ? 'bg-green-500/20 text-green-400'
                    : fb.status === 'in_progress'
                    ? 'bg-blue-500/20 text-blue-400'
                    : 'bg-yellow-500/20 text-yellow-400'
                }`}>
                  {fb.status}
                </span>
              </div>
              <span className="text-xs text-gray-500">
                {formatDate(fb.timestamp)}
              </span>
            </div>
            <p className="text-gray-300">{fb.message}</p>
            {fb.email && (
              <p className="text-xs text-gray-500 mt-2">From: {fb.email}</p>
            )}
          </div>
        ))}
      </div>

      {feedbacks.length === 0 && (
        <div className="text-center text-gray-500 py-12">
          No feedback requests yet
        </div>
      )}
    </main>
  )
}
